import { Companion_getInstance29ub64y89bvyi as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.c42_1 = operation;
        this.d42_1 = null;
        this.e42_1 = Companion_getInstance().p42_1;
        this.f42_1 = null;
        this.g42_1 = null;
        this.h42_1 = null;
        this.i42_1 = null;
        this.j42_1 = null;
        this.k42_1 = null;
        this.l42_1 = null;
        this.m42_1 = null;
        this.n42_1 = null;
        this.o42_1 = true;
      }
      q42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.d42_1 = requestUuid;
        return this;
      }
      r42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.e42_1 = executionContext;
        return this;
      }
      s42(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.l42_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      t42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.f42_1 = httpMethod;
        return this;
      }
      u42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.g42_1 = httpHeaders;
        return this;
      }
      v42(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.g42_1;
        tmp.g42_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      w42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.i42_1 = sendApqExtensions;
        return this;
      }
      x42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.j42_1 = sendDocument;
        return this;
      }
      y42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.h42_1 = enableAutoPersistedQueries;
        return this;
      }
      z42(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.k42_1 = canBeBatched;
        return this;
      }
      a43(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.m42_1 = retryOnError;
        return this;
      }
      b43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.n42_1 = failFastIfOffline;
        return this;
      }
      c43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.o42_1 = sendEnhancedClientAwareness;
        return this;
      }
      n37() {
        var tmp0_elvis_lhs = this.d42_1;
        return new (ApolloRequest())(this.c42_1, tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs, this.e42_1, this.f42_1, this.g42_1, this.i42_1, this.j42_1, this.h42_1, this.k42_1, this.l42_1, this.m42_1, this.n42_1, this.o42_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, executionContext, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.d43_1 = operation;
        this.e43_1 = requestUuid;
        this.f43_1 = executionContext;
        this.g43_1 = httpMethod;
        this.h43_1 = httpHeaders;
        this.i43_1 = sendApqExtensions;
        this.j43_1 = sendDocument;
        this.k43_1 = enableAutoPersistedQueries;
        this.l43_1 = canBeBatched;
        this.m43_1 = ignoreApolloClientHttpHeaders;
        this.n43_1 = retryOnError;
        this.o43_1 = failFastIfOffline;
        this.p43_1 = sendEnhancedClientAwareness;
      }
      q43() {
        return this.r43(this.d43_1);
      }
      r43(operation) {
        return (new (Builder())(operation)).q42(this.e43_1).r42(this.f43_1).t42(this.g43_1).u42(this.h43_1).w42(this.i43_1).x42(this.j43_1).y42(this.k43_1).z42(this.l43_1).a43(this.n43_1).b43(this.o43_1).s42(this.m43_1).c43(this.p43_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
